import img from "./error.gif";


const ErrorMessage = () =>{
    return(
        <img src={img} alt="error" width = "100%"/>
    )
}

export default ErrorMessage;